// Domínio definitivo do site (fonte única de verdade para SEO).
// Usar sempre com protocolo, SEM "www" e sempre HTTPS.
export const SITE_ORIGIN = 'https://nexussaude.com.br';

export const SITE_NAME = 'Nexus Saúde';

export const DEFAULT_OG_IMAGE =
  'https://readdy.ai/api/search-image?query=Modern%20teal%20and%20dark%20medical%20occupational%20health%20corporate%20banner%20visual%20with%20abstract%20glowing%20shapes%2C%20professional%20healthcare%20brand%20identity%2C%20clean%20minimal%20composition%2C%20high%20quality&width=1200&height=630&seq=og-nexus-home-v1&orientation=landscape';

// Imagem padrão de compartilhamento em redes sociais (1200x630).
export interface PageMeta {
  title: string;
  description: string;
}

// Título e descrição únicos por página indexável.
// Regras: title <= 60 caracteres, description entre 120 e 160.
export const PAGE_META: Record<string, PageMeta> = {
  '/': {
    title: 'Nexus Saúde | Medicina Ocupacional para Empresas',
    description:
      'Medicina ocupacional e SST para grandes empresas: gestão de absenteísmo, afastamentos e adequação à NR-1. Fale com a Nexus Saúde.',
  },
  '/pgr-pcmsco': {
    title: 'PCMSO e PGR para Grandes Empresas | Nexus Saúde',
    description:
      'Elaboração e gestão de PCMSO e PGR integrados, com NR-1, NR-7 e eSocial SST. Implantação para grandes operações em todo o Brasil.',
  },
  '/agendamento-exames-ocupacionais': {
    title: 'Agendamento de Exames Ocupacionais | Nexus Saúde',
    description:
      'Agende exames ocupacionais e ASO da sua equipe com agilidade. Rede credenciada, laudos digitais e gestão de periódicos para empresas.',
  },
  '/terceirizacao-sst': {
    title: 'Terceirização de SST para Empresas | Nexus Saúde',
    description:
      'Centralize PGR, PCMSO, exames, afastamentos e treinamentos em um único parceiro de SST. Gestão terceirizada para grandes empresas.',
  },
  '/gestao-afastados-absenteismo': {
    title: 'Gestão de Afastamentos e Absenteísmo | Nexus',
    description:
      'Reduza o absenteísmo com gestão de afastamentos baseada em dados: acompanhamento de CAT, INSS e retorno ao trabalho. Para grandes empresas.',
  },
  '/saude-mental-corporativa': {
    title: 'Saúde Mental Corporativa | Programa para Empresas',
    description:
      'Programa de saúde mental corporativa com psicoterapia online, sigilo garantido e indicadores para o RH. Apoia os riscos psicossociais da NR-1.',
  },
  '/sobre-nos': {
    title: 'Sobre a Nexus Saúde | Medicina Ocupacional desde 2008',
    description:
      'Conheça a Nexus Gestão em Saúde: desde 2008 cuidando de saúde ocupacional e SST de grandes empresas no Brasil. Nossa história e equipe.',
  },
  '/novidades-nexus': {
    title: 'Novidades Nexus | Conteúdo de Saúde Ocupacional',
    description:
      'Artigos, novidades e análises sobre medicina ocupacional, NR-1, absenteísmo e saúde mental no trabalho pela equipe da Nexus Saúde.',
  },
  '/contato': {
    title: 'Contato | Fale com a Nexus Saúde Ocupacional',
    description:
      'Fale com especialistas em medicina ocupacional e SST para grandes empresas. Solicite uma proposta ou um diagnóstico gratuito de saúde.',
  },
  '/credenciado': {
    title: 'Seja um Credenciado Nexus | Rede de Saúde Ocupacional',
    description:
      'Credencie sua clínica ou laboratório à rede Nexus e atenda grandes empresas com exames ocupacionais e ASO. Cadastro de parceiros.',
  },
  '/politica-de-privacidade': {
    title: 'Política de Privacidade | Nexus Saúde',
    description:
      'Saiba como a Nexus Gestão em Saúde coleta, usa e protege dados pessoais em conformidade com a LGPD e com as boas práticas do setor.',
  },
  '/solucoes/saude-corporativa': {
    title: 'Saúde Corporativa para Empresas | Nexus Saúde',
    description:
      'Programa de saúde corporativa com gestão de indicadores, prevenção e cuidado integrado para reduzir afastamentos em grandes empresas.',
  },
  '/solucoes/painel-gerenciador': {
    title: 'Painel Gerenciador de Saúde | Nexus Saúde',
    description:
      'Acompanhe indicadores de saúde ocupacional em tempo real: absenteísmo, exames e afastamentos em um único painel pensado para o RH.',
  },
  '/solucoes/gestao-afastados': {
    title: 'Gestão de Afastados com Nexia | Nexus Saúde',
    description:
      'Acompanhe afastamentos, prazos e retorno ao trabalho com a Nexia, a assistente de IA da Nexus. Menos trabalho operacional para o RH.',
  },
  '/solucoes/implantacao-ambulatorios': {
    title: 'Implantação de Ambulatórios | Nexus Saúde',
    description:
      'Implantamos e operamos ambulatórios dentro da sua empresa, com equipe médica dedicada e atendimento no próprio local de trabalho.',
  },
  '/solucoes/mapeamento-nr1': {
    title: 'Mapeamento de Riscos NR-1 | Nexus Saúde',
    description:
      'Mapeamento de riscos psicossociais e adequação à NR-1 com método validado e plano de ação integrado ao PGR da sua empresa.',
  },
  '/solucoes/treinamentos-nr': {
    title: 'Treinamentos NR Presenciais e EAD | Nexus',
    description:
      'Capacitação em normas regulamentadoras no presencial e a distância, com controle de validade e certificados digitais para auditoria.',
  },
  '/solucoes/entrega-epi': {
    title: 'Entrega de EPI por Biometria | Nexus Saúde',
    description:
      'Controle a entrega de EPI com biometria facial, sem retrabalho e com rastreabilidade completa para auditorias de SST e eSocial.',
  },
  '/solucoes/assistencia-medica': {
    title: 'Assistência Médica Corporativa | Nexus Saúde',
    description:
      'Atendimento médico para colaboradores dentro da empresa, com pronto atendimento e encaminhamento para a rede de saúde credenciada.',
  },
  '/solucoes/saude-mental': {
    title: 'Saúde Mental no Trabalho | Nexus Saúde',
    description:
      'Psicoterapia online e apoio psicológico para colaboradores, com indicadores de uso para o RH e apoio aos riscos psicossociais da NR-1.',
  },
  '/solucoes/nexia': {
    title: 'Nexia: Assistente de IA em Saúde Ocupacional | Nexus',
    description:
      'A Nexia é a assistente de IA da Nexus para autoagendamento de periódicos, triagem e dados de saúde ocupacional. Conheça a solução.',
  },
  // Página de login: fora do sitemap e sempre com noindex.
  '/area-do-cliente': {
    title: 'Área do Cliente | Nexus Saúde',
    description:
      'Acesso restrito a clientes Nexus para acompanhar exames, afastamentos e indicadores de saúde ocupacional.',
  },
};

// Fallback para matérias do blog (o título real é aplicado pela própria página).
const BLOG_DETAIL_META: PageMeta = {
  title: 'Novidades Nexus | Conteúdo de Saúde Ocupacional',
  description:
    'Artigos e análises sobre medicina ocupacional, NR-1, absenteísmo e saúde mental no trabalho pela equipe da Nexus Saúde.',
};

// Caminhos que devem ser indexados pelos buscadores (espelha o sitemap.xml).
export const INDEXABLE_PATHS: string[] = [
  '/',
  '/pgr-pcmsco',
  '/agendamento-exames-ocupacionais',
  '/terceirizacao-sst',
  '/gestao-afastados-absenteismo',
  '/saude-mental-corporativa',
  '/solucoes/saude-corporativa',
  '/solucoes/painel-gerenciador',
  '/solucoes/gestao-afastados',
  '/solucoes/implantacao-ambulatorios',
  '/solucoes/mapeamento-nr1',
  '/solucoes/treinamentos-nr',
  '/solucoes/entrega-epi',
  '/solucoes/assistencia-medica',
  '/solucoes/saude-mental',
  '/solucoes/nexia',
  '/sobre-nos',
  '/novidades-nexus',
  '/contato',
  '/politica-de-privacidade',
  '/credenciado',
];

// Normaliza o path: remove query/hash e barras finais (exceto a raiz).
export const normalizePath = (pathname: string): string => {
  const withoutQuery = pathname.split('?')[0].split('#')[0];
  if (!withoutQuery || withoutQuery === '/') return '/';
  return withoutQuery.replace(/\/+$/, '');
};

// Monta a URL canônica absoluta a partir de um path.
export const buildCanonicalUrl = (pathname: string): string => {
  const clean = normalizePath(pathname);
  return clean === '/' ? `${SITE_ORIGIN}/` : `${SITE_ORIGIN}${clean}`;
};

// Áreas administrativas nunca devem ser indexadas.
export const isAdminPath = (pathname: string): boolean =>
  normalizePath(pathname).startsWith('/admin');

// Matérias do blog são dinâmicas: cada slug é indexável por si só.
export const isBlogDetailPath = (pathname: string): boolean =>
  normalizePath(pathname).startsWith('/novidades-nexus/');

// Decide se a rota atual pode ser indexada.
export const isIndexablePath = (pathname: string): boolean => {
  const clean = normalizePath(pathname);
  if (isAdminPath(clean)) return false;
  if (isBlogDetailPath(clean)) return true;
  return INDEXABLE_PATHS.includes(clean);
};

// Retorna título e descrição da rota atual.
export const getPageMeta = (pathname: string): PageMeta => {
  const clean = normalizePath(pathname);
  const meta = PAGE_META[clean];
  if (meta) return meta;
  if (isBlogDetailPath(clean)) return BLOG_DETAIL_META;
  return PAGE_META['/'];
};